export default __webpack_public_path__ + "static/media/ico-doc-db-score-elevated.2319e2b8.svg";